/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N2Inputs */

const en_to_xml_ref_n2 = /** @type {(inputs: To_Xml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Array items repeat the element name of the key that held them.`)
};

const ko_to_xml_ref_n2 = /** @type {(inputs: To_Xml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 항목은 그것을 담고 있던 키의 요소 이름을 반복합니다.`)
};

const ja_to_xml_ref_n2 = /** @type {(inputs: To_Xml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の項目は、それを保持していたキーの要素名を繰り返します。`)
};

/**
* | output |
* | --- |
* | "Array items repeat the element name of the key that held them." |
*
* @param {To_Xml_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n2 = /** @type {((inputs?: To_Xml_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n2(inputs)
	if (locale === "ko") return ko_to_xml_ref_n2(inputs)
	return ja_to_xml_ref_n2(inputs)
});